import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react'; // import Checkbox from '../../Checkbox'

import Dropdown from '../../Dropdown';
import Text from '../../Text';
import Checkbox from './CheckboxCell';

var noop = function noop() {
  return null;
};

function ColumnPicker(_ref) {
  var _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$hiddenColumnIds = _ref.hiddenColumnIds,
      hiddenColumnIds = _ref$hiddenColumnIds === void 0 ? [] : _ref$hiddenColumnIds,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      restProps = _objectWithoutPropertiesLoose(_ref, ["columns", "hiddenColumnIds", "onChange"]);

  return /*#__PURE__*/React.createElement(Dropdown, _extends({
    variant: "outline",
    icon: {
      name: 'columns'
    },
    tooltip: {
      title: 'Filter Columns'
    },
    placement: "bottom-end",
    closeOnSelect: false,
    onSelect: function onSelect(columnId) {
      var newHiddenColumnIds = [].concat(hiddenColumnIds);
      var indexPosition = newHiddenColumnIds.indexOf(columnId);

      if (indexPosition > -1) {
        newHiddenColumnIds.splice(indexPosition, 1);
      } else {
        newHiddenColumnIds.push(columnId);
      }

      onChange({
        columnId: columnId,
        hiddenColumnIds: newHiddenColumnIds
      });
    }
  }, restProps), columns.filter(function (column) {
    return !column.alwaysVisible;
  }).map(function (column) {
    return /*#__PURE__*/React.createElement(Dropdown.Item, {
      key: column.id,
      value: column.id
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: hiddenColumnIds.indexOf(column.id) === -1,
      onChange: noop
    }), /*#__PURE__*/React.createElement(Text, {
      marginLeft: 1
    }, column.label || column.header));
  }));
}

export default ColumnPicker;